export default "__VITE_ASSET__BF9PNfE___"